import { ManageCommon } from "./base-manager.abstract";
import { cookies } from "../../utilities/cookie";
import { ILog } from "@ihr-radioedit/inferno-core";

const log = ILog.logger("OneTrustManagerAbstract");

export abstract class OneTrustManage extends ManageCommon {
  abstract isOptOut(): boolean;
  abstract toggleInfoDisplay(e: any): void;
  abstract setOptOutConsent(from: "ClientNavigation" | "Load"): void;
  static cookieTokenName: string;
  static cookieIdName: string;
  static cookieProfileIdName: string;
  static cookieUserTypeName: string;
  static cookieEmailName: string;
  static coastConsentId: string;
  static localConsentId: string;
  static category: string;
  static categoryValue: string;

  static checkConsentFromCookie(categoryValue: string): boolean | undefined {
    const optanonCookie = cookies().get("OptanonConsent");
    if (!optanonCookie) {
      log.debug("🚀 checkConsentFromCookie -> NO COOKIE");
      return undefined;
    }

    // Parse the groups consent value from the cookie
    const groupsMatch = optanonCookie.match(/groups=([^&]+)/);
    if (!groupsMatch) {
      log.debug("🚀 checkConsentFromCookie -> NO GROUPS MATCH");
      return undefined;
    }

    const groups = decodeURIComponent(groupsMatch[1]);

    const categoryMatch = groups.match(new RegExp(`${categoryValue}:(\\d)`));
    if (categoryMatch) {
      const isOptedOut = categoryMatch[1] === "0";
      log.debug("🚀 checkConsentFromCookie -> RESULT:", isOptedOut ? "OPTED OUT" : "OPTED IN");
      return isOptedOut;
    }

    log.debug("🚀 checkConsentFromCookie -> NO CATEGORY MATCH", categoryValue);
    return undefined;
  }
}
